import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';

const CancelPopUp = (props) => {
  const navigate = useNavigate();
  const { cancelPopUp, setCancelPopUp } = props;

  const handleNo = () => {
    setCancelPopUp(false);
  };

  const handleYes = () => {
    setCancelPopUp(false);
    navigate(-1);
  };

  return (
    <Dialog fullWidth={true} maxWidth={'xs'} open={cancelPopUp}>
      <DialogContent dividers>
        <Typography variant='h6'>Are you sure you want to exit?</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleNo}>
          No
        </Button>
        <Button variant='contained' onClick={handleYes}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelPopUp;
